import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  VStack,
  IconButton, 
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

interface FeedbackModalProps {
  buyerCompanyName: string;
  onClose: () => void;
  onYesClick: () => void;
  onNoClick: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  buyerCompanyName,
  onClose,
  onYesClick,
  onNoClick,
}) => {
  return (
    <Box w={"100%"} h={"100%"} p={4}  position="relative">
        <IconButton
        aria-label="Close feedback modal"
        icon={<CloseIcon />}
        size="sm"
        position="absolute"
        top={2}
        right={2}
        bg="gray.100"
        color="gray.600"
        onClick={onClose}
        _hover={{
          bg: "gray.200",
        }}
      />
      <VStack spacing={6} align="stretch">
        {/* Title */}
        <Text
          fontSize={"20px"}
          fontWeight={700}
          textAlign={"center"}
          color={"black"}
        >
          Feedback
        </Text>
        
        {/* Warning text*/}
        <Text
          fontSize={"12px"}
          color={"red.600"}
          textAlign={"center"}
          fontStyle={"italic"}
        >
          This feedback can be given only once and within 24 hours of closure of meeting. 
          Feedback cannot be changed once submitted.
        </Text>
        
        {/* Main question */}
        <VStack spacing={2}>
          <Text
            fontSize={"16px"}
            fontWeight={600}
            textAlign={"center"}
            color={"black"}
          >
            Were you able to connect with {buyerCompanyName} successfully?
          </Text>
          
          <Text
            fontSize={"12px"}
            color={"gray.600"}
            textAlign={"center"}
            fontStyle={"italic"}
          >
            (Your response will be visible to them.)
          </Text>
        </VStack>
        
        {/* Buttons */}
        <Flex gap={4} mt={6}>
          <Button
            flex={1}
            size={"md"}
            p={0}
            py={3}
            bg={"green.100"}
            color={"green.600"}
            onClick={onYesClick}
            _hover={{
              bg: "green.200",
            }}
          >
            Yes
          </Button>
          
          <Button
            flex={1}
            size={"md"}
            p={0}
            py={3}
            bg={"red.100"}
            color={"red.600"}
            onClick={onNoClick}
            _hover={{
              bg: "red.200",
            }}
          >
            No
          </Button>
        </Flex>
      </VStack>
    </Box>
  );
};

export default FeedbackModal;